<template>
  <div v-if="(!isFopFormParent || isValidInn) && isPdvPayer !== undefined" class="inn-info__vat-info" :class="{'inn-info__vat-info--not-payer': !isPdvPayer && !isFopFormParent}">
    <div v-if="isPdvPayer" class="checkmark"></div>
    <p v-if="isPdvPayer">{{ $t('is_VAT_payer') }}</p>
    <p v-else>{{ $t('is_not_VAT_payer') }}</p>
  </div>
</template>

<script>
export default {
  name: 'InnCheckMark',
  props: {
    isFopFormParent: {
      type: Boolean,
      required: true
    },
    isValidInn: {
      type: Boolean,
      required: true
    },
    isPdvPayer: Boolean
  }
}
</script>

<style lang="sass" scoped>

  .inn-info__vat-info
    display: flex
    align-items: center
    font-weight: 400 //Rubik 300
    width: 50%
    font-size: 14px

    +mmax($small)
      width: 100%

    &--not-payer
      margin-left: 0

  .checkmark
    display: inline-block
    margin: 0 10px 5px 0

    &:after
      content: ''
      display: block
      width: 6px
      height: 10px
      border: solid $nd-valid-border-color
      border-width: 0 1px 1px 0
      transform: rotate(45deg)
</style>
